import _slicedToArray from "/var/www/html/meameal/prod/front_meameal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { useCacheToken } from '@ant-design/cssinjs';
import version from '../version';
import { defaultTheme, DesignTokenContext } from './context';
import defaultSeedToken from './themes/seed';
import formatToken from './util/alias';
export var unitless = {
  lineHeight: true,
  lineHeightSM: true,
  lineHeightLG: true,
  lineHeightHeading1: true,
  lineHeightHeading2: true,
  lineHeightHeading3: true,
  lineHeightHeading4: true,
  lineHeightHeading5: true,
  opacityLoading: true,
  fontWeightStrong: true,
  zIndexPopupBase: true,
  zIndexBase: true
};
export var ignore = {
  size: true,
  sizeSM: true,
  sizeLG: true,
  sizeMD: true,
  sizeXS: true,
  sizeXXS: true,
  sizeMS: true,
  sizeXL: true,
  sizeXXL: true,
  sizeUnit: true,
  sizeStep: true,
  motionBase: true,
  motionUnit: true
};
var preserve = {
  screenXS: true,
  screenXSMin: true,
  screenXSMax: true,
  screenSM: true,
  screenSMMin: true,
  screenSMMax: true,
  screenMD: true,
  screenMDMin: true,
  screenMDMax: true,
  screenLG: true,
  screenLGMin: true,
  screenLGMax: true,
  screenXL: true,
  screenXLMin: true,
  screenXLMax: true,
  screenXXL: true,
  screenXXLMin: true
};
export var getComputedToken = function getComputedToken(originToken, overrideToken, theme) {
  var derivativeToken = theme.getDerivativeToken(originToken);

  var override = overrideToken.override,
      components = __rest(overrideToken, ["override"]); // Merge with override


  var mergedDerivativeToken = Object.assign(Object.assign({}, derivativeToken), {
    override: override
  }); // Format if needed

  mergedDerivativeToken = formatToken(mergedDerivativeToken);

  if (components) {
    Object.entries(components).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      var componentTheme = value.theme,
          componentTokens = __rest(value, ["theme"]);

      var mergedComponentToken = componentTokens;

      if (componentTheme) {
        mergedComponentToken = getComputedToken(Object.assign(Object.assign({}, mergedDerivativeToken), componentTokens), {
          override: componentTokens
        }, componentTheme);
      }

      mergedDerivativeToken[key] = mergedComponentToken;
    });
  }

  return mergedDerivativeToken;
}; // ================================== Hook ==================================

export default function useToken() {
  var _React$useContext = React.useContext(DesignTokenContext),
      rootDesignToken = _React$useContext.token,
      hashed = _React$useContext.hashed,
      theme = _React$useContext.theme,
      override = _React$useContext.override,
      cssVar = _React$useContext.cssVar;

  var salt = "".concat(version, "-").concat(hashed || '');
  var mergedTheme = theme || defaultTheme;

  var _useCacheToken = useCacheToken(mergedTheme, [defaultSeedToken, rootDesignToken], {
    salt: salt,
    override: override,
    getComputedToken: getComputedToken,
    // formatToken will not be consumed after 1.15.0 with getComputedToken.
    // But token will break if @ant-design/cssinjs is under 1.15.0 without it
    formatToken: formatToken,
    cssVar: cssVar && {
      prefix: cssVar.prefix,
      key: cssVar.key,
      unitless: unitless,
      ignore: ignore,
      preserve: preserve
    }
  }),
      _useCacheToken2 = _slicedToArray(_useCacheToken, 3),
      token = _useCacheToken2[0],
      hashId = _useCacheToken2[1],
      realToken = _useCacheToken2[2];

  return [mergedTheme, realToken, hashed ? hashId : '', token, cssVar];
}